import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { RouterLink, RouterModule } from '@angular/router';
import { AsyncPipe } from '@angular/common';

import { MenubarModule } from 'primeng/menubar';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { AvatarModule } from 'primeng/avatar';

import { AuthService } from 'src/app/services/auth.service';
import { ThemeService } from 'src/app/services/theme.service';
import { Theme } from 'src/app/enums/theme.enume';
import { menubarHeaderDesignToken } from 'src/app/primeng-design-tokens/menubar-header';
import { MenuItem } from 'primeng/api';
import { environment } from 'src/environments/environment';

/**
 * Main header of the application.
 */
@Component({
	selector: 'app-main-header',
	imports: [MenubarModule, AvatarModule, RouterLink, MenuModule, ButtonModule, AsyncPipe, ButtonModule, RouterModule],
	templateUrl: './header.component.html',
	styleUrl: './header.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true
})
export class HeaderComponent implements OnInit {
	public Theme = Theme;

	public title = environment.environmentName !== 'prod'
		? `Driving Restrictions ${environment.environmentName}`
		: 'Driving Restrictions';

	public menubarHeaderDesignToken = menubarHeaderDesignToken;

	public items: MenuItem[] = [];

	/**
	 * Constructor
	 * @param authService To check user data.
	 * @param launchDarklyService To get user admin status.
	 * @param themeService To toggle theme.
	 */
	constructor(
		public authService: AuthService,
		public themeService: ThemeService,
	) {}


  ngOnInit() {
	this.items = [
      { label: 'Vehicles overview', icon: 'pi pi-truck', routerLink: ['/vehicles'] },
      { label: 'FPC overview', icon: 'pi pi-sitemap', routerLink: ['/fpcs'] },
      { label: 'Restrictions', icon: 'pi pi-ban', routerLink: ['/restrictions'] },
      { label: 'Archived Restrictions', icon: 'pi pi-inbox', routerLink: ['/archived-restrictions'] }
    ];
  }
}
